/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { environment } from "../environment";
import { Headers, HttpClientOptions } from "../Utils/HttpClient";
import UiApiClient from "./UiApiClient";
import { UrlArguments } from "./UrlArguments";

export default abstract class UiJsonApiClient extends UiApiClient {
    protected constructor(path: string, _options?: HttpClientOptions, baseUrl = environment.uiBaseUrl) {
        super(path, _options, baseUrl);
    }

    protected async post<TBody, TData>(urlPath: string, value?: TBody, headers?: Headers, customRequestName?: string): Promise<TData> {
        return this.parseJson(await super.post(urlPath, value, headers, customRequestName));
    }

    protected async put<TBody, TData>(urlPath: string, value?: TBody, headers?: Headers, customRequestName?: string): Promise<TData> {
        return this.parseJson(await super.put(urlPath, value, headers, customRequestName));
    }

    protected async get<TData>(path: string, urlArguments?: UrlArguments, ignoreErrors?: boolean): Promise<TData> {
        return this.parseJson(await super.get(path, urlArguments, ignoreErrors));
    }

    protected async delete<TData>(path: string, customRequestName?: string): Promise<TData> {
        return this.parseJson(await super.delete(path, customRequestName));
    }

    protected async getText(path: string, urlArguments?: UrlArguments, ignoreErrors?: boolean): Promise<string | null> {
        const response = await super.get(path, urlArguments, ignoreErrors);
        const text = await response.text();
        if (!text) {
            return null;
        }

        return text;
    }

    private async parseJson<T>(response: Response): Promise<T> {
        const text = await response.text();
        const value = text.length ? JSON.parse(text) : null;
        return value;
    }
}
